export default __webpack_public_path__ + "static/media/live-stream_white.23d69f29.svg";